export const SUB_ACCORDION_INDENT = 2;
export const DATALABEL_PROPORTION_DISPLAY_THRESHOLD = 0.03;
